
'use strict';

const $ = require('jquery');

const description = $('#product-description');
if (description) {
    description.on('click', function() {
        $(this).toggleClass('overflow');
    });
}



$('#category-toggle').on('click', function () {
    $(this).next('#category-products').slideToggle();
});
